export enum IncidentsListEnum {
  AGENTES_TRANSITO = '148',
  AGENTES_POLICIA = '149',
  CLASE_ACCIDENTE = 'ClaseAccidente',
  CODIGO_INFRACCION = 'CodigoInfraccion',
  COMUNAS = 'comunas',
  ENCARGADO_OPERATIVO = 'EncargadoOperativo',
  ESTADO_CANCELACION_SERVICIO = 'EstadoCancelacionServicio',
  ESTADO_ACUERDO_INCIDENTE = 'EstadoAcuerdoIncidente',
  ESTADO_GESTION = 'EstadoGestion',
  ESTADO_INCIDENTE = 'Estado',
  ESTADO_QUEJA = 'EstadoQueja',
  IMPLICADO_NO = 'ImplicadoNo',
  MEDIO_REQUERIMIENTO = 'MedioRequerimiento',
  MOTIVO_CANCELACION_SERVICIO = 'MotivoCancelacionServicio',
  MOVIL_GRUA = 'MovilGrua',
  NUM_VEHICULO_INPLICADO = 'NumVehiculoImplicado',
  REGISTRO_TURNOS = 'RegistroTurnos',
  REPORTE_REALIZAR = 'ReporteRealizar',
  TIPO_AUTORIDAD = 'TipoAutoridad',
  TIPO_DANO_SEMAFORO = 'TipoDanoSemaforo',
  TIPO_DANO_SENAL = 'TipoDanoSenal',
  TIPO_GRAVEDAD_ACCIDENTE = 'TipoGravedadAccidente',
  TIPO_INCIDENTE = 'TipoIncidente',
  TIPO_INVOLUCRADOS = 'TipoInvolucrados',
  TIPO_REPORTE_VIA = 'TipoReporteVia',
  TIPO_SEMAFORO = 'TipoSemaforo',
  TIPO_SENAL_REPORTE = 'TipoSenalReporte',
  TIPO_SERVICIO = 'TipoServicio',
  TIPO_SOLICITUD = 'TipoSolicitud',
  ZONA = 'Zona',
  SITUACION = 'Situacion',
  CATEGORIA = 'Categoria',
  SUBCATEGORIA = 'Subcategoria',
  FUENTE = 'Fuente',
  MEDIO = 'Medio',
  PRIORIDAD = 'Prioridad',
  IMPACTO = 'Impacto',
  SEVERIDAD = 'Severidad',
  TIPO_VEHICULO = 'TipoVehiculo',
  ESTADO_ACTIVO = '331'
}

export enum IncidentFormEnum {
  localidad = '',
  latitude = 'latitude',
  longitude = 'longitude',
  incidentTime = 'incidentTime',
  beginDate = 'beginDate',
  endDate = 'endDate',
  orientId = 'orientId',
  brokerId = 'brokerId',
}